<div class="timeline__item dot-{{ typology?.color }}" *transloco="let t; read: 'building.history'">
  <div class="building-event-bullet-point"></div>
  <div class="timeline__divider"></div>
  <div class="timeline__content">
    <div class="timeline__date">
      <div class="date-label">{{ date | date : 'dd.MM.yyyy' }}</div>
      @if (ecab?.processingTheme) {
      <span class="type-badge">{{ formatChipLabel(ecab.processingTheme) }}</span>
      } @if (typology) {
      <span class="type-badge">{{ t('chips.typology') }}</span>
      } @if (control) {
      <span class="type-badge">{{ t('chips.control') }}</span>
      } @if (status) {
      <span class="type-badge">{{ t('chips.status') }}</span>
      } @if (itech) {
      <span class="type-badge">{{ t('chips.itech') }}</span>
      }
    </div>
    @if (typology) {
    <div class="timeline__section">
      <div>
        <span>{{ t('type', { type: 'typology' }) }}</span>
        @if (typology.source === 'automatique') {
        <span>{{ t('automaticClassification') }}&nbsp;</span>
        } @if (typology.previousColor) {
        <span>{{ t('fromColor', { color: t('colors', { color: typology.previousColor }) }) }}&nbsp;</span>
        }
        <span class="color-label" innerHTML="{{ t('toColor', { color: t('colors', { color: typology.color }) }) }}"></span>
        @if (typology.user) {
        <span>, {{ t('byUser', { user: typology.user | displayName }) }} </span>
        }
      </div>
      @if (typology.justification) {
      <div>
        <em>{{ typology.justification }}</em>
      </div>
      }
    </div>
    } @else { @if (control) {
    <div class="timeline__section">
      <div>
        <span>{{ t('type', { type: 'control' }) }}</span>
        @if (!control.reportFileName) {
        {{ t('byUser', { user: control.user | displayName }) }},
        {{ t('roles', { role: control.user?.activeRole }) }}
        }
      </div>
      <div class="buttons">
        <sibat-tertiary-button
          [label]="'building.control.previewControlReport' | transloco"
          (clicked)="previewControlReport()"
        ></sibat-tertiary-button>
        @if (canDisplayDefects$ | async) {
        <sibat-tertiary-button
          data-testid="defectsLink"
          [label]="t(control.isCompliant ? 'defectComplianceList' : 'followDefectCompliance')"
          (clicked)="displayControlDefects(control.id)"
        ></sibat-tertiary-button>
        }
      </div>
    </div>
    } @else { @if (status) {
    <div class="timeline__section">
      <span>{{ t('type', { type: 'status' }) }}</span
      >&nbsp; @if (status.status) {
      <span>{{ t('statusLabel.' + status.status) }}</span>
      } @if (status.user) {
      <span>, {{ t('byUser', { user: status.user | displayName }) }} </span>
      } @if (status.justification) {
      <span>
        <em>{{ status.justification }}</em>
      </span>
      }
    </div>
    } @else { @if (itech) {
    <div class="timeline__section">
      <div [innerHTML]="'building.technicalInstallation.installationMessage' | transloco : getItechParams(itech)"></div>
    </div>
    } @else {
    <div class="timeline__section">
      @if (ecab.requestDescription) {
      <div>{{ ecab.requestDescription }}</div>
      } @if (ecab.requestDescription && ecab.responseDescription) {
      <hr class="ecab-separator" />
      } @if (ecab.responseDescription) {
      <div>{{ ecab.responseDescription }}</div>
      }
      <div class="ecab-meta">
        @if (ecab.userEmail) {
        <span>{{ ecab.userEmail }}</span>
        } @if (ecab.source) {
        <span> · {{ ecab.source }}</span>
        } @if (ecab.applicantType) {
        <span> · {{ ecab.applicantType }}</span>
        }
      </div>
    </div>
    } } } }
  </div>
</div>
